<template>
  <LayoutTelas
    id="tela__produtos"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">

    <ProdutosCadastroForm
      ref="formProdutos"
      :dados="dadosProdutos"
      @gravar="gravar" />

  </LayoutTelas>
</template>

<script>
import ProdutosCadastroForm from './ProdutosCadastroForm.vue'
import ProdutosService from '../../../services/produtos.service'
import GeradorMensagens from '@/mixins/GeradorMensagens'

export default {
  name: 'ProdutosCadastro',
  components: {
    ProdutosCadastroForm,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      dadosProdutos: null,
      isLoading: false,
    }
  },
  beforeMount() {
    this.carregar()
  },
  methods: {
    async gravar(dados) {
      this.mostrarLoader()
      try {
        const retorno = await this.retornaMetodoGravacao(dados)
        this.tratarRespostaMsg(retorno)

        this.$refs.formProdutos.sair()
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    retornaMetodoGravacao(dados) {
      return dados._id
        ? ProdutosService.atualizar(dados)
        : ProdutosService.gravar(dados)
    },
    async carregar() {
      if (this.$route.params.id) {
        this.mostrarLoader()
        try {
          this.dadosProdutos = await ProdutosService.retornaPorId(this.$route.params.id)
        } catch (error) {
          this.tratarRespostaMsg(error)
          this.$router.push({ name: 'rota-produtos' })
        } finally {
          this.mostrarLoader(false)
        }
      }
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

#tela__produtos {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

</style>
